
import Tabbed from "./tabbed"
import with_toggle_google_street from "./with_toggle/google_street_view"
import $ from "jquery"

const onLoad = () => {
  if ($(".cell--listings--pictures-and-map-browser--tabbed").length > 0){
    Tabbed.init_with_promise().done()
  }
  with_toggle_google_street.onLoad()
}

export default {onLoad}
